
import { PanelBody, RangeControl, SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Label } from '../../../../Components';
import { orderByOpt, orderOpt } from '../../utils/options';


const QueryPanel = ({ attributes, setAttributes, allCategories }) => {
    const { categories, limit, order_by, order } = attributes;

    if (!allCategories) {
        return null;
    }

    // List of categories 
    const categoriesOpt = allCategories?.map((category) => {
        return { label: category.name, value: category.id }
    });

    return <PanelBody title={__('Query', 'swipe-n-buy')} initialOpen={false}>
        <SelectControl className='' label={__('Categories', 'swipe-n-buy')} options={[{ label: 'Select', value: '' }, ...categoriesOpt]} value={categories} onChange={(val) => {
            setAttributes({ categories: [val] });
        }} />

        <Label className='mt5'>{__('Products Limit:', 'swipe-n-buy')}</Label>
        <RangeControl value={limit} onChange={val => setAttributes({ limit: val })} min={-1} max={60} step={1} />

        <SelectControl className='' label={__('Order by', 'swipe-n-buy')} options={orderByOpt} value={order_by} onChange={(val) => { setAttributes({ order_by: val }) }} />

        <SelectControl className='' label={__('Order', 'swipe-n-buy')} options={orderOpt} value={order} onChange={(val) => { setAttributes({ order: val }) }} />
    </PanelBody>
}

export default QueryPanel;